<template>
  <div class="animated revealUp">
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("currency_conversion", 2) }}
      </div>
      <router-link class="btn-blue" to="currencies-conversion"
        >{{ $tc("currency_conversion", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in Currencies"
          :key="index"
          v-if="item.fieldname !== 'ccr_id' && item.fieldname !== 'curr_name'"
          class="col-lg-6 col-xl-4 align-self-center mb-4"
        >
          <div v-if="item.type !== 'radio' && item.type !== 'dropdown' && item.type !== 'date'">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                style="text-align:right;"
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                  placeholder="."
                />
                <label>{{ $tc(item.label, 1) }}</label>
              </div>
              <Tooltip :title="$t(item.tooltip)" />
            </div>
            <p class="error_message">
              <!-- {{ item.fieldname }} -->
              <span v-if="submitted && errors.has(item.fieldname)">
                <!-- {{errors.first(`${item.fieldname}`)}}  -->
                {{ $t(item.errormsg) }}</span>
            </p>
          </div>

          <div v-if="item.type === 'radio'">
            <div class="d-flex align-items-center min-height-50">
              <label class="mb-0 mr-3">{{ $t("active") }}</label>
              <label class="ios-switch">
                <input
                  type="checkbox"
                  class="ios-checkbox"
                  v-model="item.fieldvalue"
                />
                <span class="switch-slider"></span>
              </label>
            </div>
            <p class="error_message">
              <!-- {{ item.fieldname }} -->
              <span></span>
            </p>
          </div>

          <div v-if="item.type === 'dropdown'">
            <div v-if="item.fieldname === 'currency_id'">
              <div class="d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <label
                    :class="item.dropdownSelected.length > 0 ? 'shift-up' : ''"
                    >{{ $tc(item.label, 1) }}</label
                  >
                  <b-dropdown
                    :text="item.dropdownSelected"
                    variant="dropdown-curve"
                    class="w-100"
                  >
                    <b-dropdown-item
                      v-for="(dropdownItem, dropdownIndex) in currency_list"
                      :key="dropdownIndex"
                      href="#"
                      @click="
                        onDropdownChange(
                          $event,
                          item.label,
                          dropdownItem,
                          index
                        )
                      "
                      >{{ dropdownItem.curr_name }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>

                <Tooltip :title="$t(item.tooltip)" />
              </div>
              <p class="error_msg">
                <span v-if="submitted && item.dropdownSelected.length == 0">{{
                  msgcountry
                }}</span>
              </p>
            </div>
          </div>

          <div v-if="item.type === 'date'">
            <div class="d-flex align-items-center">
              <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="item.fieldvalue"
                  v-on:click.prevent.stop="clearSelectedDate()"
                >✖</button>
                <Datepicker :monday-first="true"
                  ref="programaticOpen"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                  :typeable="true"
                ></Datepicker>
                <label
                  :class="typeof item.fieldvalue === 'object' ? 'active': ''"
                >{{ $tc(item.label, 1) }}</label>
                <!-- <label
                    :class="item.fieldvalue.length > 0 ? 'shift-up' : ''"
                    >{{ $tc(item.label, 1) }}</label
                  > -->
              </div>
            </div>

              <Tooltip :title="$t(item.tooltip)" />
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has(item.fieldname)">
                {{ $t(item.errormsg) }}</span>
            </p>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="onFinalSubmit(true)"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(false)"
            type="submit"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="currencies-conversion"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CurrenciesConversion from "@/helper/formJSONMaster/CurrenciesConversion";

export default {
  data() {
    return {
      btenable: false,
      Currencies: CurrenciesConversion.m_currency_conversion_rate_to_base,
      msgcountry: "Please select currency",
      // v-validate="'required|email'"
      submitted: false,
      Methods: CurrenciesConversion.Methods,
      currency_list: [],
    };
  },
  beforeMount() {
    this.getCurrencyList();
    this.onResetForm();
  },
  mounted() {},
  methods: {
    clearSelectedDate: function () {
      this.Currencies[3].fieldvalue = "";
    },
    getCurrencyList: function () {
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/",
        tableName: "ms_currencies",
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.currency_list = data.Records;
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error2 :", error);
        });
    },
    onFocusHandler: function () {
      // this.submitted = false;
    },
    onDropdownChange: function (event, type, item, mainIndex) {
      this.Currencies[mainIndex].fieldvalue = item.curr_id;
      this.Currencies[mainIndex].dropdownSelected = item.curr_name;
    },
    onResetForm: function () {
      this.Currencies.map((x) => {
        console.log("x :>> ", x);
        if (x.type === "text" || x.type === "date" || x.type === "number") {
          x.fieldvalue = "";
        } else if (x.type === "dropdown") {
          x.dropdownSelected = "";
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },
    onFinalSubmit: function (redirect) {
      console.log("call submit :");
      this.submitted = true;

      this.$validator.validate().then((valid) => {
        if (this.Currencies[2].fieldvalue == "") {
          return false;
        }
        if (valid) {
          this.btenable = true;
          let body = this.getRequestBody("POST", this.Currencies, this.Methods);

          MasterService.GlobalRequest(body)
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data.status) {
                this.onResetForm();
                if (redirect) {
                  this.$router.push({
                    path: "/master/currencies-conversion",
                  });
                }
              } else {
                // Show Error Message:
                this.$toasted.show(data.message);
                console.log("data.message :", data.message);
              }
            })
            .catch((error) => {
              // Catch Error:
              console.log("Catch Error On onFinalSubmit :", error);
            });
        } else {
          console.log("else :");
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/CurrencyConversionComponents/addCurrencyConversion.vue